import { AuthService } from './auth.service';
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { ReportCompanyHieracyDTO, ReportGenericCompanyDTO, ReportInvoiceCompanyDTO, ReportInvoiceCompanyFilterDTO } from "../models/reportList.model";


@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private http: HttpClient, private authService: AuthService) {

  }

  getTotEmessoAnnuale(fk_company: number, anno) {
    return this.http.get<any>(environment.apiFullUrl + '/Report/GetTotEmessoAnnuale/' + fk_company + "/" + anno).toPromise();
  }

  getIncassiAnnuali(fk_company: number, anno) {
    return this.http.get<any>(environment.apiFullUrl + '/Report/GetIncassiAnnuali/' + fk_company + "/" + anno).toPromise();
  }

  getTotFattureAnnuali(fk_company: number, anno) {
    return this.http.get<any>(environment.apiFullUrl + '/Report/GetTotFattureAnnuali/' + fk_company + "/" + anno).toPromise();
  }

  getPagamentiEseguitiAnnuali(fk_company: number, anno) {
    return this.http.get<any>(environment.apiFullUrl + '/Report/GetPagamentiEseguitiAnnuali/' + fk_company + "/" + anno).toPromise();
  }

  getReportCompanyHierarchy() {
    return this.http.get<Array<ReportCompanyHieracyDTO>>(environment.apiFullUrl + '/Report/GetReportCompanyHierarchy').toPromise();
  }

  getReportGenericCompany() {
    return this.http.get<Array<ReportGenericCompanyDTO>>(environment.apiFullUrl + '/Report/GetReportGenericCompany').toPromise();
  }

  getReportInvoiceCompany() {
    return this.http.get<Array<ReportInvoiceCompanyDTO>>(environment.apiFullUrl + '/Report/GetReportInvoiceCompany').toPromise();
  }

  getFilteredReportInvoiceCompany(filters: ReportInvoiceCompanyFilterDTO) {
    return this.http.post<Array<ReportInvoiceCompanyDTO>>(environment.apiFullUrl + '/Report/GetFilteredReportInvoiceCompany', filters).toPromise();
  }

  getUsersByCompanyRelationID(id: number) {
    return this.http.get<any>(environment.apiFullUrl + '/Report/GetUsersByCompanyRelationID/' + id).toPromise();
  }

  RF19Forecast(fk_company: number, anno) {
    return this.http.get<any>(environment.apiFullUrl + '/Report/RF19Forecast/' + fk_company + "/" + anno).toPromise();
  }

  exportReportCompanyHierarchyXls() {
    window.open(environment.apiFullUrl + '/Report/GetExportReportCompanyHierarchyXls' , '_blank');
  }

  exportReportCompanyHierarchyCsv() {
    window.open(environment.apiFullUrl + '/Report/GetExportReportCompanyHierarchyCsv', '_blank');
  }

  exportReportGenericCompanyXls() {
    window.open(environment.apiFullUrl + '/Report/GetExportReportGenericCompanyXls', '_blank');
  }

  exportReportGenericCompanyCsv() {
    window.open(environment.apiFullUrl + '/Report/GetExportReportGenericCompanyCsv', '_blank');
  }

  exportReportInvoiceCompanyXls(filters: ReportInvoiceCompanyFilterDTO) {
    window.open(environment.apiFullUrl + '/Report/GetExportReportInvoiceCompanyXls/' + filters.AnnoRiferimento + '/' + filters.FattureCategory + '/' + filters.FattureProduct , '_blank');
  }

  exportReportInvoiceCompanyCsv() {
    window.open(environment.apiFullUrl + '/Report/GetExportReportInvoiceCompanyCsv' , '_blank');
  }
}
